import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const TheNewCollege = () => {
  const [toggle, setToggle] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [joint, setJoint] = useState(false)
  const [hons, setHons] = useState(false)
  const [princpal, setPrincpal] = useState(false)
  const [fifth, setFifth] = useState(false)
  const [Sixth, setSixth] = useState(false)
  const [sev, setSev] = useState(false)
  const [eigth, setEigth] = useState(false)
  const [nine, setNine] = useState(false)
  const [tenth, setTenth] = useState(false)
  const [eleven, setEleven] = useState(false)
  const [tweal, setTweal] = useState(false)
  const [theten, setTheten] = useState(false)
  const [fourten, setFourten] = useState(false)
  const [fiftens, setFiftens] = useState(false)


  function updateToogle(id) {
    setToggle(id)
  }


  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → The New College</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>College Crest</li>
            <li className={toggle === 2 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(2)}>Annual Report</li>
            <li className={toggle === 3 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(3)}>Principal Down the Year</li>
            <li className={toggle === 4 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(4)}>Profile Of the Institutions</li>
            <li className={toggle === 5 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(5)}>Vision & Mission</li>
            <li className={toggle === 6 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(6)}>Time Line</li>
            <li className={toggle === 7 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(7)}>Document</li>
            {/* <li className={toggle === 8 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(8)}>Archives</li> */}
            {/* <li className='tab-title'>MEASI Charitable Trust</li> */}
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <h1>COLLEGE CREST</h1>



            <div className='tab-para'>
              <div className='tab-img'>
                <img src='https://sedge.in/New%20College/assest/logo.png' style={{ width: "20%", height: "auto" }} />
              </div>
              <p>⬣ The Crescent and the Star in the College Crest represent progress and light and also embody Islamic Culture .</p>
              <p>⬣ The Lotus represents Indian Culture.</p>
              <p>⬣ The Torch represents Enlightenment and knowledge and the Palm represents Sweetness and Fruitfulness. The Arabic verse is a prayer which means ‘’Ya Allah increase my knowledge”</p>
              <p>⬣ The background colours of the College Crest are green and red.</p>
              <p>
                ⬣ The green colour indicates Prosperity and the red colour Sacrifice.</p>
            </div>
          </div>

          {/* Second Tab Details */}

          <div className={toggle === 2 ? "show-tab-content" : 'tab-content'}>
            <h1>Annual Report</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ 2016 - 2017 </button>
            {
              isOpen && (
                <div >
                  <div className='ssr-items'>
                    {/* This is the starting node of AQARREPORTS */}

                    <p style={{ fontWeight: "700" }}>Annual Report For The Year Of 2016 - 2017</p>
                    <div>
                      <div className='aqar-items'>
                        <a href='https://thenewcollege.edu.in/pdf/annual-reports-2016-17.pdf' target='new'>
                          <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                          <h3>2016 - 2017</h3>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ 2017 - 2018 </button>
            {
              joint && (
                <div >
                  <div className='ssr-items'>
                    {/* This is the starting node of AQARREPORTS */}

                    <p style={{ fontWeight: "700" }}>Annual Report For The Year Of 2017 - 2018</p>
                    <div>
                      <div className='aqar-items'>
                        <a href='https://thenewcollege.edu.in/pdf/annual-reports-2017-18.pdf' target='new'>
                          <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                          <h3>2017 - 2018</h3>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ 2018 - 2019 </button>
            {
              hons && (
                <div >
                  <div className='ssr-items'>
                    {/* This is the starting node of AQARREPORTS */}

                    <p style={{ fontWeight: "700" }}>Annual Report For The Year Of 2018 - 2019</p>
                    <div>
                      <div className='aqar-items'>
                        <a href='https://thenewcollege.edu.in/pdf/annual-reports-2018-19.pdf' target='new'>
                          <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                          <h3>2018 - 2019</h3>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


            <button onClick={() => setPrincpal(e => !e)} className='tab-open-btn'>✠ 2019 - 2020 </button>
            {
              princpal && (
                <div >
                  <div className='ssr-items'>
                    {/* This is the starting node of AQARREPORTS */}

                    <p style={{ fontWeight: "700" }}>Annual Report For The Year Of 2019 - 2020</p>
                    <div>
                      <div className='aqar-items'>
                        <a href='https://thenewcollege.edu.in/pdf/annual-reports-2019-20.pdf' target='new'>
                          <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                          <h3>2019 - 2020</h3>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

            <button onClick={() => setFifth(e => !e)} className='tab-open-btn'>✠ 2020 - 2021 </button>
            {
              fifth && (
                <div >
                  <div className='ssr-items'>
                    {/* This is the starting node of AQARREPORTS */}

                    <p style={{ fontWeight: "700" }}>Annual Report For The Year Of 2020 - 2021</p>
                    <div>
                      <div className='aqar-items'>
                        <a href='https://thenewcollege.edu.in/pdf/annual-reports-2020-21.pdf' target='new'>
                          <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                          <h3>2020 - 2021</h3>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

          </div>

          {/* Third Tab Details */}

          <div className={toggle === 3 ? "show-tab-content" : 'tab-content'}>
            <h1>Principal Down the Year</h1>
            <div>
              <div >

              </div>
            </div>
          </div>

          {/* Fourth Tab Details */}

          <div className={toggle === 4 ? "show-tab-content" : 'tab-content'}>
            <h1>Profile oF The Institution</h1>
            <div>
              <div >
                <table>
                  <tr>
                    {/* <th>
                      </th>
                    <th></th>
                    <th></th> */}
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Name of the College</td>
                    <td>The New College</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Date of Establishment</td>
                    <td>1951</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Place</td>
                    <td>Chennai</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>State</td>
                    <td>Tamil Nadu</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Affiliating University</td>
                    <td>	University of Madras, Chennai – 600 005.</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Status of the College</td>
                    <td>Autonomous</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Accreditation</td>
                    <td>Accredited by NAAC with ‘A++’ grade in the 4th cycle</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Funding Status of the College</td>
                    <td>Grand-in-aid for Shift-I Programmes Self-financing for Shift-II Programmes</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Type of the College</td>
                    <td>Mens’ College</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Date of Conferment of Autonomous Status</td>
                    <td>2007</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Location of the College</td>
                    <td>No:#147 / 87, Peters Road, Royapettah, <br></br>
                      Chennai – 600 014. Tamil Nadu. India <br></br>
                      Landmark: Near Royapettah Govt. Hospital</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Campus Area</td>
                    <td>14 Acres</td>
                  </tr>
                </table>

                <h2>Number of Departments</h2>


                <table>
                  <tr>
                    <th>S.No</th>
                    <th>Aided:</th>
                    <th>Self-financing:</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Arts - 06</td>
                    <td>Arts - 06</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Science - 05</td>
                    <td>	Science - 07</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Commerce - 02</td>
                    <td>Commerce - 05</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Language - 03</td>
                    <td>Language - 03</td>
                  </tr>
                </table>

                <h2>Number of Programmes</h2>

                <table>
                  <tr>
                    <th>S.No</th>
                    <th>Aided:</th>
                    <th>Self-financing:</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>UG - 13</td>
                    <td>	UG - 12</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>PG - 07</td>
                    <td>PG - 08</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>M.Phil., - 07</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Ph.D., - 11</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Diploma - 01</td>
                    <td></td>
                  </tr>
                </table>

              </div>
            </div>
          </div>

          {/* Fifth Tab Details */}

          <div className={toggle === 5 ? "show-tab-content" : 'tab-content'}>
            <h1>Vision & Mission</h1>
            <div className='fourth-tab-para'>
              <div>
                <h3>Vision</h3>
                <p>⬣ To promote educational and economic equity by helping aspiring and underprivileged youth gain access to quality education and to nurture them into successful model citizens of the country.</p>
                <br></br>
                <br></br>
                <h3>Mission</h3>
                <p>⬣ To follow a 5E holistic development approach that strives to
                  ELEVATE underprivileged students with affordable education
                  EDUCATE through a qualitative platform and updated pedagogy
                  EMPOWER the students by instilling right values, skills and confidence
                  ENGAGE students in real life situations and transform them into responsible leaders of tomorrow
                  EXCEL in all aspects of governance, education and development</p>
                <br></br>
                <br></br>
                <h3>CORE VALUES</h3>
                <p>⬣ Inclusivity</p>
                <p>⬣ Student Centric</p>
                <p>⬣ Excellence</p>
                <p>⬣ Leadership Development</p>
                <br></br>
                <br></br>
              </div>
            </div>
          </div>

          {/* Sixth Tab Details */}

          <div className={toggle === 6 ? "show-tab-content" : 'tab-content'}>
            <h1>Time Line</h1>
            <button onClick={() => setIsOpen(e => !e)} className='tab-open-btn'>✠ 1835-1910 </button>
            {
              isOpen && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1835</td>
                      <td>Under the advice of Lord Macaulay, Law Member in the Governor General Council, Lord William Bentinck Governor General of India passed the Educational Resolution in favour of English Education on 7th March</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1871</td>
                      <td>The backward condition of education among the Muslims attracted the attention of the Government of India and passed a resolution for the encouragement of education among the Muslims on 7th August</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1882</td>
                      <td>The Indian Education Commission dealt with the question of Muslim education and failure of the English education to Muslim community</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1886</td>
                      <td>Sir Syed Ahmed Khan found the Muhammadan Educational Congress and its first session held at Aligarh in December.</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1901</td>
                      <td>Fifteenth Annual session of the Muhammadan Educational Conference held at the Cathedral garden, Teynampet, Madras, from 27th to 31st December and Presided by Justice Hungerford Tudor Boddam, Judge, High Court of Madras</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1902</td>
                      <td>
                        Muhammadan Educational Association of Southern India (MEASI) founded in January <br></br>
                        Justice Hungerford Tudor Boddam, Judge, High Court of Madras became the Founder President of MEASI</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1904</td>
                      <td>The first Annual Report of the MEASI was published.</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1906</td>
                      <td>MEASI incorporated as a society under "The Registration of Literary, Scientific and Charitable Societies Act XXI of 1860" on 7th February<br></br>
                        Provincial Conference of MEASI held at Vellore</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>1908</td>
                      <td>Janab Nawab Syed Mahmood, Grandson of Tippu Sultan became the President of MEASI</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>1910</td>
                      <td>Janab Justice Sir Abdur Rahim became the President of MEASI</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setJoint(e => !e)} className='tab-open-btn'>✠ 1911-1947 </button>
            {
              joint && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1912</td>
                      <td>Janab Justice F. Badruddin Tyabji was elected as President, when Janab Justice Sir Abdur Rahim had to proceed England</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1915</td>
                      <td>Lord Pentland laid the foundation for the construction of Boddam Muslim Hostel in memory of the founder President Justice H.T. Boddam, in Singanna Naik Street, George Town on 12th April</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1916</td>
                      <td>Janab Justice Sir Abdur Rahim again elected the President of MEASI after his return from England</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1918</td>
                      <td>Boddam Muslim Hostel function with the grants from Government and the funds available from the Association</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1920</td>
                      <td>Janab Sir Mohamed Habibullah elected as President of MEASI</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1924</td>
                      <td>Janab Nawab C. Abdul Hakim Sahib elected as President of MEASI</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1925</td>
                      <td>Janab Sir Mohamed Usman Sahib elected as President</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1929</td>
                      <td>The Government of Madras Presidency gave statutory recognition to the MEASI and nominated representatives to the Senate of Madras University, Annamalai University and District Educational Council</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>1935</td>
                      <td>Boddam Muslim Hostel celebrates its Silver Jubilee on 6th and 7th May <br></br>
                        Janab Jamal Mohamed Sahib became the President</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>1938</td>
                      <td>Association present a Memorandum to the Government of Madras, embodying all the needs of Muslims in the field of Education on 5th March</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>1941</td>
                      <td>Association pass a resolution urging the Government for the appointment of Muslims on the Bench of Madras High Court, in the Department of Registration and as District Munsifs <br></br>
                        Janab Hajee Azeem Sahib, elected as President and Janab Malang Ahmed Batch Sahib Hony. Secretary</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>1944</td>
                      <td>Janab Khan Bahadur Jawad Hussain Sahib elected as President</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>1945</td>
                      <td>Janab Malang Ahmed Batcha Sahib elected as President and Janab Justice Basheer Ahmed Sayeed Sahib as Hony. Secretary</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>1946</td>
                      <td>Muhammadan Educational Association of Southern India renamed as Muslim Educational Association of Southern India- MEAS as per the order of the Government</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td>1947</td>
                      <td>The Government of Madras changes the name of the ‘Government Mohammadan College’ into 'Government Arts College' and abolishes the reservations to Muslim Students.Moulvi M. Nazir Hussain Sahib became the President</td>
                    </tr>
                  </table>
                </div>
              )
            }

            <button onClick={() => setHons(e => !e)} className='tab-open-btn'>✠ 1948-1955 </button>
            {
              hons && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1949</td>
                      <td>
                        MEASI purchased 12 acres of land with two storeyed building, on 26th March., originally the land known as ‘Tawkars Garden’ later called as ‘Limbdi Garden’ at 49, Peters Road, Royapettah, for a sum of Rs. 4,36,000/- now it was known as ‘Association Garden’ <br></br>
                        Hon’ble Sri K. Madhava Menon, Minister for Education, Government of Madras opened the “Association Hostel” (Boddam Muslim Hostel shifted from George Town) in Associations Garden, 49, Peters Road, Royapettah on 12th August <br></br>
                        MEASI applied for affiliation of The New College to Madras University in October <br></br>
                        Janab Basher Ahmed Sayeed Sahib, the Hony. Secretary of MEASI appointed as the Judge of High Court of Madras hence Janab M.S.A. Majeed Sahib elected as Hony. Secretary</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1950</td>
                      <td>Constituted an Adhoc Committee to organize and Collect funds for the establishment of the College <br></br>
                        MEASI applied again for affiliation of The New College to Madras University on 25th October</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1951</td>
                      <td>Dr. A Lakshmanaswamy Mudaliar, Vice-Chancellor of Madras University and his team inspects the Associations Garden in Peter’s Road on 2nd March <br></br>
                        Affiliation granted to the New College on 29th March to admit 200 students for the following Intermediate courses:- 1) Mathematics, Commerce and Geography each one paper 2) Mathematics, Commerce and History each one paper 3) Two History paper and Geography one paper 4) Two History paper and Psychology one paper 5) Two History paper and Commerce one paper 6) Two History paper and Mathematics one paper 7) Two History paper and Logic one paper and 8) Three History papers <br></br>
                        His Excellency Dr. Rajendra Prasad, President of the Republic of India visits the Association Garden on 8th April <br></br>
                        Sri. C. Rajagopalachari, Home Minister of Government of India, inaugurates the College on 2nd July. Professor J. Franco took over as the first Principal of THE NEW COLLEGE on 2 July</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1952</td>
                      <td>Dr. M.V. Krishna Rao, Education Minister of Government of Madras, opened the newly constructed “The Nazir Husain Hall” on 28th July</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1953</td>
                      <td>Nawab Zain Yar Jung Bahadur of Hyderabad visited and grant a fund for the New College in January <br></br>
                        South Indian Education Delegation visit South East Asia for collecting funds to The New College & Jamal Mohamed College under the leadership of Janab Quaid-Millath M. Muhammed Ismail Sahib, M.P., the President of Indian Union Muslim League and the members Janab M.S.A. Majeed, Sahib Hony. Secretary of the New College and Janab M.J. Jamal Mohideen, Sahib Secretary, Jamal Mohamed College, Trichy</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1954</td>
                      <td>His Holiness Sardar Dr. Sayedna Tahar Saifuddin Sahib, Chancellor of the Aligarh Muslim University visited and donate Rs. 2000/- to the College on 12th February <br></br>
                        Khan Sahib Bade Gulam Ali Khan, the great musician and artist of International fame visits the College on 15th February <br></br>
                        A Cultural delegation from Afghanistan includes Vice- Minister of Afghanistan visited the College on 21st February <br></br>
                        Special Inspection Commission under Prof. J. Sundara Rao of Presidency College from University of Madras to the affiliation of Physics, Chemistry and Natural Science on 27th March <br></br>
                        Second visit of the Commission from University of Madras to the affiliation on 16th June and granted permission for admitting 144 students for 1) Mathematics, Physics and Chemistry and Physics, Chemistry and Natural Science(Botany & Zoology). But reduced the original strength of Humanities to 156 from 200. Hence the overall strength of the College fixed as 300 <br></br>
                        Shri K. Kamaraj Nadar, the Chief Minister of Madras, declared opened the New Science Block named as "Burma Malaya Block" on 18 July <br></br>
                        Honourable M. Bhaktavatsalam, Minister of Agriculture of Government of Madras, visited the College on Graduation Day</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1955</td>
                      <td>Golden Jubilee Celebration of MEASI from 5th to 9th February, His Excellency Shri Prakasan, the Governor of Madras delivered the inaugural speech on 5th February and Dr. Zakir Husain, Vice Chancellor of Aligarh University and Dr. A Lakshmanaswamy Mudaliar, Vice-Chancellor of Madras University participated. <br></br>
                        Senior A.M.A. Azeez, Principal of Zahiria College, Colombo visited participated in the 'celebration of Tamil Muslim Poets' on 6th February <br></br>
                        Dr M.H.M. Faridani, Cultural Counselor to the Iranian Embassy in India visited on 8th February <br></br>
                        Musical performance of Ustad Bade Gulam Ali Khan, a great musician and artist of international fame on 8th February <br></br>
                        His Highness Prince Aly Salman khan visited the College on 19th February <br></br>
                        Strength of the College increased into 572 (Junior and Senior Intermediate 286 each)
                        Dr. P.V. Cherian, Chairman of Legislative Council of madras visited our College on 4th August <br></br>
                        Jesse Owens, the World Renowned Sprinter visited and addressed in the College on 13th October</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setPrincpal(e => !e)} className='tab-open-btn'>✠ 1956-1961 </button>
            {
              princpal && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1956</td>
                      <td>Boddam Muslim Hostel celebrates its Silver Jubilee on 6th and 7th May
                        Pre-University Classes were started <br></br>
                        Sri P.V. Rajamannar, Chief Justice of Madras presided the College and Sports Day on 22nd February <br></br>
                        Professor V. Thiruvenkatacharya took over as the Principal on 1 June. <br></br>
                        Maulana Husain Ahmed Madani, Principal, Darul Uloom, Deoband laid the foundation for the New College Masjid on 2nd August <br></br>
                        Mr. A.C. Norminton, Asst. Regional Representative of the British Council in Madras visited the College on 13th August <br></br>
                        Mr. T. Chengalvarayan, Ex- mayor of Madras visits on 1st December</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1957</td>
                      <td>
                        The College upgraded with Degree Courses in B.A. (History & Politics and Economics)), and B. Sc. (Mathematics, Chemistry, Zoology) <br></br>
                        Mr. K.G. Saiyadain, Secretary for Education, Government of India opened the extension building of 'Burma Malaya Block' on 29th January <br></br>
                        General Carriappa, Ex- Commander in Chief of Indian Army visits on 31st January <br></br>
                        Sri C.R. Srinivasan, Great Journalist and Editor of ‘Swadesamitram’ visits the College on 2nd March <br></br>
                        Sri S. Teyyappa Thevar, Collector of Madras visits the College on 12th August</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1958</td>
                      <td>Professor Syed Abdul Wahab Bukhari Saheb took over as the Principal on 1st April
                        Sri M. Bhaktavalsalam, Home Minister of Government of Madras, visits the College on 27th January <br></br>
                        Thomas W. Simons, Counsel General of USA visits the College on 27th January <br></br>
                        Aringer C.N. Annadurai, M.L.A. visits the College on 8th August <br></br>
                        New College Fine Arts Association presents Shakespeare’s Macbeth Drama at the Museum theatre from 13th to 15th November and familiars as dignitaries like Dr. A  <br></br>Lakshmanaswamy Mudaliar, Vice-Chancellor of Madras University, His Highness Prince of Arcot and Sri C. Subramanian, Education Minister attend the programme</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1959</td>
                      <td>Sri R. Venkataraman, Labour Minister of Government of Madras, Mr. Dawood Ali Mirza, Member of Parliament and Mr. Allah Pichai, the Deputy Chairman of the Legislative Council visits the College on 27th January <br></br>
                        His Excellency Sri Bhisnuram Medhi, the Governor of Madras inaugurate the Annual Day celebration of the College on 11th February <br></br>
                        Dr. Sir C.P. Ramaswami Aiyer visits the College on 14th February <br></br>
                        His Excellency Sheik Yusuf Al Fouzan, Ambassador of Saudi Arabia in India opened the New College Masjid on 17th April <br></br>
                        Col. B.H. Zaidi, Vice Chancellor of Aligarh Muslim University, visits the College on 25th October <br></br>
                        Kalainjer M. Karunanidhi, M.L.A. visits the College on 25th November <br></br>
                        Sri Sivaji Ganesan, popular Cine artist visits the College on 8th December <br></br>
                        Sri Humayun Kabir, Minister of Scientific Research and Cultural Affairs, Government of India, inaugurate the ‘Physics Block’ on 24th December</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1960</td>
                      <td>Started B.Sc. Physics <br></br>
                        Introduced B.Sc. Physics Degree Course <br></br>
                        Hafiz Mohamed Ibrahim, Cabinet Minister, Government of India visits the College on 11th January <br></br>
                        Sri M.G. Ramachandran, popular Cine artist visited the campus and witness Tamil Drama ‘Ungal Thirpu’ on 4th February <br></br>
                        Dr. Jan Marek, Professor of Oriental Studies from Czechoslovakia visits the College on 21st February <br></br>
                        Shri B. Gopala Reddy, Minister of Revenue and Civil Expenditure, Government of India laid the foundation stone for the New College Hostel on 25th June and Hon’ble Shri C. Subramaiam, Minister for Finance and Education, Government of Madras also witnessed the event <br></br>
                        Mr. Prem Nazir, popular Malayalam Cine artist visits the College on 2nd August</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1961</td>
                      <td>The Student strength of the College increased to 850 (Pre-University 510 & Degree 340) <br></br>
                        Justice Kunhammed Kutty, Madras High Court visits the College on 19th March <br></br>
                        Prof. K. Neelakanta Sastri famous Historian visits the College on 26th October</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setFifth(e => !e)} className='tab-open-btn'>✠ 1962-1970 </button>
            {
              fifth && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1962</td>
                      <td>Introduced B.Sc. Botany Degree Course <br></br>
                        Principal, Syed Abdul Wahab Bukhari Saheb represent India in Millennium Celebration of Ali-Kindi in Baghdad and participate the World Seminar of Philosophers and Historians. <br></br>His speech in Arabic catch the headlines of Press both in India and abroad
                        Janab M.S.A. Majid Sahib elected as the President of MEASI <br></br>
                        Dr. A. L. Mudaliar Vice-Chancellor of Madras University visits the College on 19th March <br></br>
                        Sri Patanjali Sastri, Chief Justice of India (retired) visits the College on 27th July <br></br>
                        Sri Chellapandian, Speaker of Madras legislative Assembly visited on 28th August <br></br>
                        Sri Bhaktavalsalam, Education and Finance Minister of Government of Madras visits on 20th November</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1963</td>
                      <td>
                        The New Hostel Block completed <br></br>
                        The First floor over the 'Physics Block' was completed <br></br>
                        Shri K. Kamaraj, President of the Indian National Congress and Sri Baktavatsalam, Chief Minister of Madras visits the College on 20th December</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1964</td>
                      <td>The Second floor works of the ‘Physics Block’ and ‘Burma Malaya Block’ were completed<br></br>
                        Diamond Jubilee of MEASI celebrated in The College Campus from 24th to 30th December <br></br>
                        His Excellency Dr. Zakir Hussain, Vice-President of India, His Excellency Sri Prakasam, Governor of Madras, Dr. A. Lakshmanaswamy Mudaliar, Vice-Chancellor of Madras  University, Dr. C. Rajagopalachari and Dr. C.P. Ramaswami Iyer visits the College during the Diamond Jubilee celebration</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1965</td>
                      <td>Introduced M.A. Arabic, the first Post Graduate Course in the College <br></br>
                        The Student strength of the College has risen to 1477 <br></br>
                        Janab A.A. Rasheed Sahib became the Hony. Secretary of MEASI <br></br>
                        Hostel Block opened <br></br>
                        The Students, Staff and Management donate Rs. 10,000/- (the highest contribution of any College in the State) to the National Defene Fund, received by Sri. Bakhtavatsalam Chief Minister of Madras on 27th September <br></br>
                        The University and Director of Medical Services given the opportunity for taking I.M.B.B.S. integrated Course</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1966</td>
                      <td>The Evening College Session begins to function in the College <br></br>
                        The New College contributed Rs 7,000/- to the Jawans’ Welfare Fund to Maj. General Virendra Singh, Director General of N.C.C. and the College receive a message of appreciation for the contribution from Prime Minister Indira Gandhi on 1st February <br></br>
                        Shri. K. Kamaraj Nadar visits the College on 18th March <br></br>
                        Sri. Jayashankar, an alumnus and popular Cine artist invite as chief guest for the stage of Tamil Drama performed in the Campus</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1967</td>
                      <td>Professor A. Gopalakrishna took over as the Principal of THE NEW COLLEGE on 1st June <br></br>
                        Anaykar Haji A. Abdus Shukur Sahib Auditorium opened <br></br>
                        Sri Sadiq Pasha, Minister of Health and Sri Madhilalagan, Minister of Revenue and Food, Government of Tamil Nadu visited our campus <br></br>
                        Introduced Second batch of B.Sc. Chemistry</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1968</td>
                      <td>Introduced B.Com Degree Course <br></br>
                        A reception organized on 7th March to honor Maulana Syed Abdul Wahab Bukhari Sahib, the Principal of the College, after he represent India at the Millenary celebration of Al-Khudi at Baghdad <br></br>
                        Janab A.K.A. Abdul Samad Sahib elected as the President of MEASI <br></br>
                        Many eminent personalities like His Excellency Abdul Aziz Al Shamali, Kuwait, Thiru Nedunchezhiyan, Minister for Education, Thiru Madhavan, Minister for Law, Thiru Muthuswami, Minister for Local Administration, and Ex. Lt. Governor Santhanam and Maulana Mufti Ziaul Huq, President of Jamiatul Ulema-e-Hind, Delhi visited our College
                        Centre for Islamic Studies and Research’ started in the College in February <br></br>
                        Thiru M. Karunanidhi, Minister for Public Works Government of Tamil Nadu inaugurated the Student Union on 28th October <br></br>
                        Thiru S.J. Sadiq Basha, Minister for Health Government of Tamil Nadu inaugurated the Seerathnnabi celebration <br></br>
                        Padmashri N.D. Sundaravadivelu, Chief Education Advisor to the Government of Tamil Nadu inaugurated the ‘Iqbal Mandram’ on 6th November</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1969</td>
                      <td>His Excellency Anas Yousef Yassin, Ambassador for Saudi Arabia in India laid the foundation stone for ‘Administrative Block’ on 4th April <br></br>
                        Dr. H. Mohamed Mohideen took over as the Principal of THE NEW COLLEGE on 1st June <br></br>
                        Introduced B.A. English Literature and M.A. Economics<br></br>
                        The ‘Student Community Development Block’ opened</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>1970</td>
                      <td>Introduced B.A. Philosophy Course <br></br>
                        A ‘Shopping Complex’ at the Western end of the College Campus construct to the income for College <br></br>
                        Dr. Allen Davies, Professor of English from Edinburgh University visits our College on February <br></br>
                        Janab A.A. Rashid Sahib, Honorary Secretary opened the Staff Lounge on 12th January</td>
                    </tr>
                  </table>
                </div>
              )
            }

            <button onClick={() => setSixth(e => !e)} className='tab-open-btn'>✠ 1971-1978 </button>
            {
              Sixth && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1971</td>
                      <td>Introduced M.Com & M. Sc Zoology Course <br></br>
                        The Evening Session of the College upgraded with new courses - B.A. History & Economics and B. Sc Mathematics, Chemistry & Physics</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1972</td>
                      <td>
                        Padmashri Tiru N.D. Sundara Vadivelu, Vice Chancellor of University of Madras opened the ‘Chemistry Laboratory Block’ on 21st December <br></br>
                        Janab A.A. Rasheed Sahib, Honorary Secretary, elected to the Senate of University of Madras from Registered Graduate Constituency <br></br>
                        Shaik Nazmi Abdul Badei Mohamed, Visiting Professor of Arabic from Al- Azhar University of Cairo joined in the Arabic Department <br></br>
                        Thiru. Jayakanthan, popular play writer visits the College on 4th September <br></br>
                        Thiru Kannadasan, popular writer and Poet visits the College on 8th September <br></br>
                        Thiru K. Balachandar, popular Film Director visits the College on 10th November <br></br>
                        Mr. Yashiro Matsuoka, Consul General of Japan in Madras visits the College on 12th November <br></br>
                        Mr. M.G. Karpov of the Consulate of USSR in Madras Visits the College on 15th November</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1973</td>
                      <td>Introduced M.A. English Literature and M. Sc Chemistry course <br></br>
                        Dr. C.J Alexopoulos Professor of University of Texas, USA visits the College on 19th January <br></br>
                        Dr Alex C. Hastle, Dundee University, Scotland, visits the College on 9th February <br></br>
                        Students from Kuwait University visits the College on 24th February <br></br>
                        Hon’ble Justice M.M. Ismail visits the College on 15th August <br></br>
                        Mr. A. M. A. Azeez, Principal of Zahira College, Colombo, inaugurate the first Tamil Nadu Muslim Educational Conference held in the Campus on 22nd &23rd September and began the ‘OMEIAT’</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1974</td>
                      <td>Janab Habibulla Badsha Sahib, member of The New College Managing Committee, appointed as the Public Prosecutor to the Government of Tamil Nadu on 28th March. <br></br>
                        Mr. T.T.P. Abdullah, former Ambassador of India to Saudi Arabia and Prof. V. Abdur Raheem, professor of Madeena University visit the College on 2nd September <br></br>
                        Familiar personalities like Janab Sulaiman Sait, M.P., Janab C.H. Mohammed Koya, M.P., C. Subramanian, Union Minister; S.J. Sdiq Pasha, State Minister; Mr. Jamini Ganesan and Sashi Kapur, popular Cine artists visited the College and attend in different functions <br></br>
                        Students from Kuwait University visits the College on 24th February <br></br>
                        Hon’ble Justice M.M. Ismail visits the College on 15th August <br></br>
                        Mr. A. M. A. Azeez, Principal of Zahira College, Colombo, inaugurate the first Tamil Nadu Muslim Educational Conference held in the Campus on 22nd &23rd September and began the ‘OMEIAT’</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1975</td>
                      <td>Philosophy Department converted into Social Science Department <br></br>
                        M. Phil. Course in Chemistry introduced and the department elevated as Research department <br></br>
                        Dr. Abdel Halim Mahmud, the Grand Shaik of the Al-Azhar University visits the College on 9th November</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1976</td>
                      <td>Celebration of Silver Jubilee of the New College and Platinum Jubilee of the MEASI
                        Prime Minister Indira Gandhi opened the ‘Administrative Block’ as part of the Silver Jubilee celebrations on 14th February <br></br>
                        His Excellency Mirza Hassan Al Sayegh, Counsel General of UAE visits the College on 19th January <br></br>
                        Shri Shafi Qureshi, Minister of State, the Ministry of Railways, Government of India visits the College on 7th February <br></br>
                        Dr. Clovis Maqsood, representative of the Arab League, Cairo visits the College on 5th March <br></br>
                        His Excellency Shri Mohanlal Sukhadia, Governor of Tamil Nadu, visits the College on 29th September <br></br>
                        Introduced B.A. Corporate Secretaryship</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1977</td>
                      <td>UGC Committee for P.G. Departments visited the College <br></br>
                        Dr. V.C. Kulandaiswamy, Director of Technical Education, Government of Tamil Nadu visits the College on 7th March <br></br>
                        His Excellency Sheik Abdul Rahman Al-Husaya of the Muslim League World, Sheik Abdulla Malabari, Post Master General of Mecca <br></br>
                        Mr. Seshan IAS visits the College <br></br>
                        Prof. Hassan Ali Tamman, the delegate of Al-Azhar University, Cairo visit the College on 4th December</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1978</td>
                      <td>Social Science Dept. subsequently converted as B.A. Sociology Department <br></br>
                        Janab A.A. Rrasheed Sahib elected as the President of MEASI and Janab A.J. Abdul Razack Sahib as the Hony. Secretary <br></br>
                        Sheik Muhammed Sharawi, the Minister of Awqaf and Al-Azhar Affairs, Egypt and Dr. Abdul Wadood Shalabi, Editor-in-Chief, Al-Azhar Journal, Cairo, visit the College
                        Dr. C.R. Ramachandran, renowned Historian, visits the College on 23rd February <br></br>
                        The College organized Silver Jubilee Celebrations from 7th March to 10th March which was inaugurated by Dr. Malcolm S. Adiseshiah, Vice Chancellor of the University of Madras on 7th March <br></br>
                        Introduced Ph. D. Research in Chemistry Department</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setSev(e => !e)} className='tab-open-btn'>✠ 1979-1987</button>
            {
              sev && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1979</td>
                      <td>The Drug Standardization Research Unit (Unani), Central Council for Research in Unani Medicine, Ministry of Health and Family Welfare, Government of India, New Delhi attached with P.G. and Research Department of Chemistry <br></br>
                        Mr. M.A. Latheef, Professor of English, elect to the Senate of the University of Madras from the Graduates’ Constituency <br></br>
                        Fr. Bryroest Crollious, Prof. of Comparative Religion, Georgina University, Rome, visits the College <br></br>
                        Thiru R.M. Veerappan, Minister for Information and Broadcasting and Religious Endowments, and Thiru C. Aranganayagam, Minister for Education, Government of Tamil Nadu visit the College</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1980</td>
                      <td>
                        Delegates of Al-Azhar University, Professor Abdul Salam Jawahri, visiting Professor Hasan Ali Tammam, and Professor Sheik Sayeed Tulba, visited the College <br></br>
                        Mrs. Radha Bumier, General Secretary of Theosophical Society visits the College <br></br>
                        Mr. E.C.P. Prabhakar IAS, Secretary, Ministry of Education, Government of Tamil Nadu visits the College</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1981</td>
                      <td>
                        Professor T. Mohamed Dawood Khan took over as the Principal on 1st June <br></br>
                        introduced M. Phil and Ph.D. Research in Zoology department  <br></br>
                        Prof. Syed Ameeruddin of English represented India at the 5th World Congress of Poets held at San Francisco in July and was honored with a D.Litt. degree for his achievements in the field of Poetry He was also interviewed by the B.B.C. London <br></br>
                        Prof. Shaik Ishaq, Head of the Dept. of Hindi, present a paper in International <br></br>Religious Conference held at Hyderabad and his paper was broadcasted by B.B.C. London on 21st May</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1982</td>
                      <td>Introduced B.A. Arabic Literature  <br></br>
                        Janab T. Abdul Wahid Sahib elected as the President  <br></br>
                        Honourable Justice Pakkir Mohamed Sahib, Additional Chief Justice, Madras High Court visits the College on 6th November</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1983</td>
                      <td>Introduced M.Phil and Ph.D (Part-time) Research in Commerce Department
                        Introduced M.A. Tamil Course <br></br>
                        Delegate from Al-Azhar University under Shaik Rajab Mujaahid visit the College on 28th March <br></br>
                        Demise of Two eminent personalities of the New College, Al-Haj Janab Abdul Wahab Bukhari Sahib, Former Principal and Janab Syed Abbas Sahib, Prof. & Head of the Dept. of History & Politics <br></br>
                        Dr. M.A. Ali, renowned scientist from the Dept. of Biological Sciences, University of Montreal, Canada visits the College on 12th January <br></br>
                        Professor Paul Piriot, an eminent Mammalogist and Professor Litulaire in the University of Montreal, Canada visits the College on 10th February <br></br>
                        Prof. P.K. Menon, an eminent International repute Zoologist visits the College on 2nd March</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1984</td>
                      <td>Introduced B.Com in Evening Session <br></br>
                        Prof. K. Anbalagan, visits the College on 21st March <br></br>
                        Honorable Minister Thiru K. Thirunawukkarasu, Minister for Industries, Govt. of Tamil Nadu visited the College in November <br></br>
                        Mr. W.V. Raman of I. B.A. (C.S) has selected to represent Madras University, Tamil Nadu Ranji Trophy and to represent India against visiting West Indies under-22 Cricket team played at Trivandrum</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1985</td>
                      <td>
                        The Drug Standardization Research Unit (Unani), attached with P.G. and Research Department of Chemistry, receive the Ajmal Khan Rolling Shield at the Scientific Seminar held at Aligarh Muslim University in February <br></br>
                        Professor M.D. Parthasarathy, an eminent Ethologist visits the College on 12th March
                        Honorable Dr. H.V. Hande, Minister for Health and Family Welfare, Government of Tamil Nadu, visits the College on 10th April <br></br>
                        All India Symposium on Animal Behavior and 14th Annual Conference of the Ethological Society of India held in the New College from 21st to 23rd June <br></br>
                        MEASI Platinum Jubilee Higher Secondary School formally opened on 1st July <br></br>
                        Prof. Syed Ammeruddin of English participate in the Eighth World Congress of Poets held at Florida, USA in September <br></br>
                        Mr. Alan Malay, First Secretary, British High Commission visits the College on 9th October <br></br>
                        Mr. W.V. Raman of II. B.A. (C.S) was selected to represent Tamil Nadu Ranji Trophy and represent India against visiting England Cricket team <br></br>
                        Introduced M. Phil Research in English department <br></br>
                        Shaik Rajab Al-Mujaahid, Al-Azhar University, Cairo, visits the College on 27th December</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1986</td>
                      <td>Hon’ble Justice S. Mohan, High Court of Madras, visits the College on 21st January <br></br>
                        Dr. Syed Ali, Head of the Arabic Department invited for the interfaith meeting held at Rajaji Hall, Madras, address by His Eminence Pope John Paul II on 5th February <br></br>
                        Dr. M. Karunanidhi, MLC, President of DMK, visits the College on 21st March <br></br>
                        Delegates from Pakistan, represent World Health Organisation, along with Hakim MA Razzack, Director, and Prof. Hakim Syed Khaleefathulla, Chairman, Scientific Advisory Committee, Central Council for Research in Unani Medicine, New Delhi, visited the UNANI unit of the College on 27th October</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>1987</td>
                      <td>Introduced B.Sc Computer Science the first among the Men’s College in Madras city
                        Miss Saroj Kharparde, Hon,ble Union Minister of State for Health and Family Welfare , New Delhi, visits the UNANI unit of the College on 5th January <br></br>
                        Dr. M. Karunanidhi, MLC, President of DMK, visits the College on 21st March <br></br>
                        Mr. K.P.Suresh, final B.Com student received a certificate of Merit from City Police Commissioner for his bravery for rescuing a drowning man from Coom River on 17th May
                        Dr. H. Mohamed Mohideen appointed as the Principal of THE NEW COLLEGE for the Second time on 1st June <br></br>
                        The New College Institute of Management (NCIM) inaugurated Sri S. Padmanabhan, Chairman and Managing Director, Indian Overseas Bank on 22nd October <br></br>
                        Maulana Hafiz Qari Mohamed Qasim Ansari Bhopali and Moulana T.M.A.K. Anwari, Editor, Arabic Tamil Dictionary visit the College on 25th November <br></br>
                        Alhaj T. Abdul Wahid Sahib, Chairman of the Managing Committee open the ‘Khan Bahadur Hajee Mohemed Aziz Basha Pavilion” on 21st December <br></br>
                        Prime Minister Rajiv Gandhi opened the newly constructed ‘Library Building’ and ‘Humanities Block’ on 22nd December and inaugurate the VIII National Conference of All India Educational Society held in New College from 22nd to 24th December, Shree Narasimha Rao, Minister for Human Resource, Government of India and Janab A. Rahim, former Deputy Minister for Foreign Affairs, Government of India participated</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setEigth(e => !e)} className='tab-open-btn'>✠ 1988-1995 </button>
            {
              eigth && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1988</td>
                      <td>Introduced B. Sc Computer Science in Evening Session <br></br>
                        Janab K.V.M. Abdul Kareem Sahib elected as Hony. Secretary <br></br>
                        Dr. S. Sathick, Director, Madras Institute of Techenology, visits the College on 21st March <br></br>
                        Dr. A. Gnanam, Vice Chancellor of University of Madras opened the ‘Language Block’ on 4th August<br></br>
                        Started Madras Study Centre II for ‘IGNOU’ Courses in College Campus</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1989</td>
                      <td>
                        Professor G. Mohamed Farhathullah took over as the Principal of THE NEW COLLEGE on 1 June <br></br>
                        Department of Economics upgraded with M.Phil course <br></br>
                        Kalainger M. Karunanidhi Chief Minister of Tamil Nadu visits the College on 22nd February <br></br>
                        Youth Red Cross and Roteract Club of New College was formed on 7th July <br></br>
                        Sri S.J. Sadiq Basha, Minister for Law, Government of Tamil Nadu visit College on 8th August <br></br>
                        Mr. R.G. Garde, Pro Vice Chancellor of IGNOU visited the College</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1990</td>
                      <td>Introduced two more batches of B. Sc Computer Science in Evening Session <br></br>
                        Sri N. Manoharan, Minister for Revenue, Government of Tamil Nadu, M. K. Stalin, M.L.A., and A. Rahman Khan, M.L.A. visit the College on 14th February <br></br>
                        Mr. Radha Ravi, alumnus of the College and popular Cine Actor visits on 18th February <br></br>
                        Mr. Mohamed Ali, Former World Heavy Weight Champion visits the College <br></br>
                        Mr. Mujibur Rahman, I B.A. Economics student represent Tamil Nadu Cricket Team and represent Indian Cricket Team under 19 to Dhaka <br></br>
                        Mr. D. Senthuswaran, II B.Com student represent India in first Indo- Egyptian Basketball Test held at Cairo</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1991</td>
                      <td>Janab M. Md. Hashim Sahib elected as the President and Janab U. Md. Khalilullah Sahib became the Hony. Secretary of MEASI <br></br>
                        Justice D. Raju, Madras High Court, visits the College on 23rd February <br></br>
                        Sri R.M. Veerappan, Minister for Education, Government of Tamil Nadu inaugurated the ‘MEASI Academy’ coaching centre for Subordinate Service examinations on 29th July <br></br>
                        MEASI Charituble Trust registered on 24th January</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>1992</td>
                      <td>MEASI Computer Academy registered on 22nd April <br></br>
                        Introduced B.E.S. (Electronics) Course in the Evening Session <br></br>
                        Indian Overseas Bank Extension Counter opened in the Campus <br></br>
                        Mr. Salman Khursheed, Deputy Minister for Commerce, Government of India visits the College on 28th January</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>1993</td>
                      <td>Introduced M.Phil course in Tamil Department and M.C.A. in Computer Science Department <br></br>
                        Introduced B. Sc. Micro Biology in Evening Session <br></br>
                        Nawab Md. Abdul Ali, Crown Prince of Arcot, visits the College on 20th February <br></br>
                        Mr. C.R. Viswanathan, President, Tamil Nadu Olympic Association visits the College on 22nd February <br></br>
                        Mr Tanweer Jabbar, II B.A. Economics student represented India in the International Triangle Under 19 Cricket Tournament held at South Africa against England and South Africa</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>1994</td>
                      <td>Dr. Major. M. Jailani took over as Principal of THE NEW COLLEGE on 1 June
                        Introduced B.B.A Course in Evening Session <br></br>
                        Justice P.S. Mishra, Madras High Court visits the College on 2nd April <br></br>
                        Mr. S.R. Karuppannan, Chairman, Tamil Nadu Public Service Commission visits the College on 10th February <br></br>
                        Dr. Sultan Ahamed Ismail, Professor of Zoology receives EXNORAS Friend of the Environment Award from Chief Minister Dr. Selvi. J. Jayalalitha on 19th February</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>1995</td>
                      <td>Introduced M.Phil course in Arabic Department <br></br>
                        Introduced B.Sc. Bio Chemistry and B.Sc. Visual Communication in Evening Session <br></br>
                        New College Institute of Management started on 16th March <br></br>
                        Institute of Soil Biology and Bio Technology started on 29th November <br></br>
                        The Newly constructed Hajee Anaikar Abdur Shukoor Auditorium opened on 21st December</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setNine(e => !e)} className='tab-open-btn'>✠ 1996-2001 </button>
            {
              nine && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>1996</td>
                      <td>104th Birthday celebration of Dr. S. R. Ranganathan, the Father of Library Science as Librarian’s Day held at The New College and Prof. K. Anbazhagan, Minister for Education, Government of Tamil Nadu, participate in the celebration held on 12th August <br></br>
                        Prof. V. Abdur Rahim, former Professor of Madina University, visits the College on 2nd September <br></br>
                        Tamil Nadu Islamic Tamil Literature Conference held in the College campus on 28th & 29th December</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>1997</td>
                      <td>
                        Janab U. Mohamed Khalilullah Sahib became the Chairman and S.C.M. Jamaldeen Sahib as Hony. Secretary of MEASI <br></br>
                        Introduced M.A. History, B.B.M. and M.A. Corporate Secretaryship in the Evening College Session <br></br>
                        Justice M.A. Sathar Sayeed Sahib, Former Judge of Madras High Court open the New College Canteen</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>1998</td>
                      <td>Introduced Ph. D. Research in Arabic Department <br></br>
                        Introduced B.C.A. in Evening Session <br></br>
                        Mr. I.K. Gujral, Prime Minister of India presence the Gold Medal to Sgt. M. Afroz Ahmed of II B.Sc. Computer Science, in the All India Best Cadet Competition during Republic Day Ceremony held at New Delhi on 27th January <br></br>
                        Thiru M. Thamizh Kudimagan, Minister for Tamil Development and Culture, Government of Tamil Nadu visits the College on 10th November</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>1999</td>
                      <td>Bharat Ratna Shri C. Subramaniam visits the College on 6th March <br></br>
                        N.C.C. Sgt. Afroz Ahmed of II B.Sc. Computer Science, attend the Youth Exchange Programme held at Nepal during February <br></br>
                        Tmt. G. Thilakavathi, IPS, Inspector General of Police, Railways visits the College on 17th March <br></br>
                        Shri K. Anbalagan, Minister of Tamil Nadu opened the newly constructed ‘Computer Science Block’ on 23rd June <br></br>
                        MEASI Academy of Architecture started in the New College Campus on 24th September <br></br>
                        Introduced M.Sc. Computer Science and B.C.A. II Batch in Evening Session <br></br>
                        Mr. Syed Munir Huda, IAS visits the College on 12th October</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>2000</td>
                      <td>
                        Professor N. Ahmed Basha took over as Principal of THE NEW COLLEGE on 1st June <br></br>
                        Introduced Ph. D. (Full-Time) course in Tamil <br></br>
                        Mr. A. Mohammed Aslam, IAS, Joint Commissionar, Prohibition & Excise, Government of Tamil Nadu visits the College on 26th January <br></br>
                        Dr. S. Muthukumaran, Member Secretary, Tamil Nadu State Council for Higher Education visits the College on 8th February <br></br>
                        A Science Exhibition (NEW SCI 2K) conducted in the College from 9th to 13th February</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>2001</td>
                      <td>Professor Mir Hadi Ali took over as Principal of THE NEW COLLEGE on 1st June <br></br>
                        Introduced B.I.S.M, B.C.A. (III Batch) and M.Sc. IT in Evening Session <br></br>
                        Demolition of the Old Monumental New College Building in May <br></br>
                        Introduced of Ph. D.(Full-Time) course in Commerce Department <br></br>
                        Capt. Zahid Hussain, Company Commander of New College NCC Infantry Unit led the NCC contingent of Tamil Nadu during Republic Day parade at New Delhi <br></br>
                        Historian Dr. Sheik Ali, former Vice Chancellor of Goa and Mangalore University visits the College on 25th January</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setTenth(e => !e)} className='tab-open-btn'>✠ 2002-2004 </button>
            {
              tenth && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2002</td>
                      <td>
                        The MEASI Centenary & The New College Golden Jubilee Celebration held at College Campus from 16th to 19th January, Prominent personalities of various fields like His Excellency Dr. C. Rangarajan, Governor of Tamil Nadu, Thiru O Panneer Selvam, Chief Minister of Tamil Nadu, Dr. (Mrs) Najma Heptulla, Deputy Chairperson, Rajya Sabha, Ministers Thiru Dr.M. Thambi Durai, Thiru C. Ponnaiyan and Thiru Anver Rhazza, Justice D.Raju, Alumnus of the College and Judge, Supreme Court, Justice B. Subhashan Reddy, Chief Justice, Madras High Court, Dr. U. Srinivasa Raghavan, Chief Postmaster General, Tamil Nadu Circle, Janab Abid Hussain, former Ambassador to USA, Janab A.M. Khusro, former Chairman, Planning Commission, Government of India, Prof. Tahir Mahmood, former Chairman, National Commission for Minorities, Dr. Pon Kothandaraman, Vice Chancellor of University of Madras, Ms. Khadidjatou (Angela Williams), Deputy Chief Consular Services, American Consulate of Chennai, Mrs. Safia Iqbal, Educationist, New Delhi, Ms. Qudsia Gandhi, IAS, Chairperson, Tamil Nadu Corporation for Women’s Development, Justice S.M. Abdul Wahab, Chairman Tamil Nadu Administrative Tribunal, Kaviko S. Abdur Rahman, Sri Qamarul Hasan, Minister for Housing, Government of Karnataka, Prof. Gopichand Narang, Vice Chairman, National Council for Promotion of Urdu language, New Delhi, Moulana Qazi Mujahidul Islam Qasmi, President, All India Muslim Law Board, New Delhi, Dr. R. Natarajan, Chairman, All India Council for Technical Education, Dr. Muthukrishnan, President, Computer Society for India, Mr. Jawad K. Hasan, Vice President, Nest Group of Companies, USA, Mr. Gul Mohamed Iqbal, former Vice-Chairman, IBM India, Ghazal artists Talat Aziz and Jaspinder Narula, Music Maestro-Poet NaushadAli participated the function held in the New College <br></br>
                        Thiru O. Panneer Selvam, Chief Minister of Tamil Nadu opened the MEASI Centenary Building on 16th January <br></br>
                        Sri Atal Behari Vajpaye, Prime Minister of India present the NCC Best Directorate Award to BN CUO VRSA Mahboob Basha, B.A. History final year student during the Republic Day Ceremony held at New Delhi on 27th January <br></br>
                        The New College Staff Association celebrate the Golden Jubilee of the New College on 18th March
                        Professor Avaram Abdul Hakeem took over as Principal of THE NEW COLLEGE on 1 June <br></br>
                        Janab Moulana Qari Mohemed Kasim Sahib Bhopali open the New Minaret of the New College Masjid on 27th December</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2003</td>
                      <td>
                        Prof. T. Mohamed Zakriah Badsha, former Joint Director of Collegiate Education visits the College on 29th January <br></br>
                        VRSA Mahboob Basha, M.A. History received the best student award from Thiru. S. Jayakumar, Law Minister of Tamil Nadu</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>2004</td>
                      <td>Janab K. Ameenur Rahman Sahib elected as the Chairman and Janab H.M. Shamsudeen Sahib as the Hony. Secretary of MEASI <br></br>
                        Mr Tanweer Jabbar, II B.A. Economics student represented India in the International Triangle Under 19 Cricket Tournament held at South Africa against England and South Africa <br></br>
                        Prof. S. P. Thiagarajan, Vice Chancellor of University of Madras visits the College on 6th October <br></br>
                        P.G. Dept. of Zoology conducted a International Seminar from 4th to 6th October</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setEleven(e => !e)} className='tab-open-btn'>✠ 2005-2008 </button>
            {
              eleven && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2005</td>
                      <td>The New College accredited with B++ Grade in the 1st Cycle accreditation by the National Accreditation and Assessment Council (NAAC) <br></br>
                        Professor A. Kadar Basha took over as Principal of THE NEW COLLEGE on 1 June <br></br>
                        Introduced M.Com. (CS) and M.Sc. Visual Communication in the Evening Session <br></br>
                        Mr. Aejaz Ahmed, former Indian basket ball Player visits the College on 25th February <br></br>
                        Mr. M.S. Jaffer Sait, DIG of Police visits the College on 19th March <br></br>
                        Dept. of Historical Studies in collaboration with MEASI and Young men Crescent Society release a book “Yousuf Khan” written by Dr. Asadulla Khan, former Head of the Dept. on 4th April <br></br>
                        Darpan authored by Dr. Md. Ubaidur Rahman, Head of the Dept. of Urdu released on 5th March</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2006</td>
                      <td>
                        Col. VAM Hussain, NCC Group Head Quarter, Chennai visits the College on 22nd July
                        National Seminar conducted the Department of Plant Biology & Plant Biotechnology on 31st January <br></br>
                        National Seminar conducted the P.G. Department of Tamil on 18th March <br></br>
                        Prof. Dr. Ronald M. Atlas, Director, Bio warfare, Bioterrorism and Bio defense, Advisor to White House, USA release the special issue of papers preented in the International Seminar conducted by the Dept. of Zoology on 8th July <br></br>
                        Mr. Md Fariz I BCS was represent the Tamil Nadu Tennis Team at the National level Competition and also select for Advanced Training at Nick Bolletteeri Academy in Florida USA <br></br>
                        Mr. Zahid Khan III BCS and Mr. Md. Nabeel, II B. Sc Comp. Sci. represent Tamil Nadu Snooker Team in All India National Snooker Championship <br></br>
                        Prof. Mushirul Hassan, Vice Chancellor, Jamia Millia Islamiah University, New Delhi given A Special Lecture on Sacchar Committee’s Report on Muslim Community organize the Dept. of Historical Studies on 20th December</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>2007</td>
                      <td>The College obtains Autonomous status <br></br>
                        Dr. Sultan Ahamed Ismail, Head, P.G. Dept. of Biotechnology invited to deliver lectures at the U.S. Composting Council Meet held at Orlando, Florida, USA in January <br></br>
                        Thiru S.N.M. Ubaydulla, Minister of Commercial Taxes, Government of Tamil Nadu visits the College on 8th March <br></br>
                        National Seminar on “Value Added Tax” conducted the P.G. & Research Department of Commerce on 7th & 8th March <br></br>
                        Two Days UGC National Seminar organize the P.G. & Research Department of English on 13th & 14th March</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>2008</td>
                      <td>Dr. K. Altaff took over as Principal of THE NEW COLLEGE on 1 June. <br></br>
                        Justice K.N. Basha, Judge, Madras High Court, visits the College on 19th January <br></br>
                        Dr. S. Mani, Dean, College Development Council, University of Madras visits the College on 2nd February <br></br>
                        MEASI and The New College Staff Association jointly organized a Seminar on The Rights and Problems of Minority Educational Institutions and Shri. P.A. Inamdar, President Maharashtra Cosmopolitan Education Society, Pune, Prof. K.A. Kader Mohideen, M.P., President, Indian Union Muslim League, Dr. K. Ponmudi, Minister of Higher Education, Government of Tamil Nadu participated the Seminar held on 19th February <br></br>
                        Dept. of Historical Studies organized felicitation to Mr. VRSA Mahboob Basha, former student, (B.A. History & M.A. History,1999-2004) for his accomplishment in Civil Service Examination of 2007 and selection to Indian Foreign Service, Sri TPM Mohideen Khan, Minister for Environment, Youth and Sports Affairs & Wakf Board, Dr. Prateep Philip IPS, IG Human Rights and Justice, Commodore UN Chitnavis, NM-DDG TNP & AN were participat the function held on 7th July <br></br>
                        Dr. K. Gulam Dasthagir, Reader in Sociology received the Best Employee State Award of the Government of Tamil Nadu from Thiru M K Stalin, Home Minister, Government of Tamil Nadu on International Day for the Disabled for his outstanding performance among visually Challenged employed and self employed persons in Tamil Nadu on 8th December</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setTweal(e => !e)} className='tab-open-btn'>✠ 2009-2011 </button>
            {
              tweal && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2009</td>
                      <td>Professor KM Kader Mohideen, Member of Parliament visits the College on 27th February <br></br>
                        Dr. C.A.M.A. Haq, HOD of Chemistry appointed as the Nodal Officer for the Orientation Programme for newly appointed Government College Teachers, sponsored by UGC and TANSCHE, held at the New College from 9th July to 5th August <br></br>
                        Prof. Lyk Burris, University of Michigan, USA visits the College on 18th August <br></br>
                        An E-Magazine “New Musings” launches on internet website by the Department of English in August <br></br>
                        Dr. K. Altaf, Principal invite to the Institute of Marine Biology, National Taiwan Ocean University, Taiwan to chair the Session in the International Conference held from 6th to 11th October <br></br>
                        Dr. Mohamed Ibrahim Naveed, Asst. Professor of Zoology, participated in a conference organized by Eskisehir Osmangazi University from 5th to 12th October <br></br>
                        Dr. K. Gulam Dasthagir, Asst. Professor of Sociology, invited to chair a Session in the International  <br></br>Association of Computer Science and Information Technology, Singapore organized from 10th to 12th October <br></br>
                        Dr. V. Abdul Rahim, Director, Translation Centre, King Fahad Holy Quran Printing Complex, Kingdom of Saudi Arabia visits the College on 19th October <br></br>
                        Dr. K. Altaf, Principal, associate with many Major Research projects funded by Atomic Energy Regulatory Board, Government of India; by NAIP ICAR, Government of India and by Tamil Nadu Urban Infrastructure Financial Services Limited, (more than Rs 31 lakhs)</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2010</td>
                      <td>
                        Introduced M. Sc Mathematics in the Evening Session <br></br>
                        The New College re-accredited with A grade and a GPA of 3.18 out of 4 by NAAC <br></br>
                        Dr. Qazi S. Azher, Associate Director, Department of Pathology, Michigan State, USA visits the College on 26th January <br></br>
                        Dr. Hans Uwe Dahms, Prof. of Environmental Biology, Sangmyung University, South Korea visits the College on 4th February <br></br>
                        Dr. K. Altaf, Principal, invited to IIM, Lucknow, to attend the 7th Management Development Programme held from 22nd to 26th February <br></br>
                        Dr. Ubaidur Rahman, Dept. of Urdu receive Dr. Allama Iqbal award from His Excellency Surjit Singh Barnala, Governor of Tamil Nadu on 26th September</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>2011</td>
                      <td>Janab Alhaj U. Mohamed Khalilullah Sahib became the Chaiman and Janab Alhaj A Mohamed Ashraf Sahib elected as Hony. Secretary of MEASI <br></br>
                        Prof. Dylan Edwards and Dr. Grant Wheeler, Molecular Biologist and Cancer Experts, University of East Anglia, England visit the College on 17th February</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setTheten(e => !e)} className='tab-open-btn'>✠ 2012-2015 </button>
            {
              theten && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2012</td>
                      <td>PG & Research Department of Economics conducted an International Conference on “Global Economic Crises: An Islamic Perspective” from 5th & 6th March <br></br>
                        Dr. S. Abdul Maliq took over as Principal of THE NEW COLLEGE on 1 June <br></br>
                        Introduced E- Urdu Centre in the College on 14th July <br></br>
                        Dr. V. Abdul Rahim, Director, Translation Centre, King Fahad Holy Quran Printing Complex, Al Madeenah al Munawwarah, Kingdom of Saudi Arabia visits the College on 10th September <br></br>
                        Justice G.M. Akber Ali, Additional Judge of Madras High Court, visits the College on 13th October <br></br>
                        Delegates from Syria and Oman visit the College <br></br>
                        Mr. Aadesh K. Chetty, I B. Sc Vis. Com won Gold, Silver and Bronze medals (different events) in the 56th  <br></br>National Shooting Championship held at New Delhi in December and created new meet record in 10 mts. Air Rifle Junior men in the Pre Nationals Shooting Championship held at New Delhi</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2013</td>
                      <td>
                        The Autonomy Review Committee headed by Dr. Amarjit Singh Dua visits the College on 4th & 5th January and extended the Autonomous status of the College <br></br>
                        Sri Palaniappan, Minister of Education, Government of Tamil Nadu visits the College on 14th Febuary <br></br>
                        Dr. Nirmala S. Maurya, Professor, Dakshin Bharat Hindi Prachar Sabha visits the College on 22nd February <br></br>
                        The New College Staff Association and New College Alumni Trust jointly organized a One Day Seminar on Importance of Today’s Higher Education and its Expectations as a mark of Diamond Jubilee Celebrations of The College <br></br>
                        The PG & Research Dept. of Tamil, Semmozhi Tamilaivu and Thirukkural Uraiaivu jointly organized a Three Day National Seminar from 2nd to 4th March  <br></br>
                        College Sports Pavilion under UGC Funding was opened</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>2014</td>
                      <td>His Excellency Hamid Ansari, Vice President of India inaugurated the Diamond Jubilee celebrations of the New College</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>2015</td>
                      <td>The college applied to NAAC for 3rd Cycle re-accreditation  <br></br>
                        Honorable A.P.J. Abdul Kalam, former President of India, visits the college and deliver the convocation address
                        Introduced M.Sc. Physics, and B.A. Urdu <br></br>
                        Prof. Fayaz Mohammed Bijli, Head of the Department of Commerce appointed as the Coordinator of the Internal Quality Assurance Cell (IQAC) of THE NEW COLLEGE <br></br>
                        The Student Development Center (SDC) started with an aim of extending Psychological Counselling and Guidance for Students on their Personal, Academic and Career related topics. Prof. P. Ibrahim, M.Sc., M.Phil., (Psychology) was appointed as the Student Development Counsellor /Co-coordinator <br></br>
                        Department of Mathematics conducted a UGC funded seminar and workshop on 5th October <br></br>
                        Dr. J. Sulaiman presented a Paper in the International Conference held at Bangkok, organised by Institute of Research Engineers and Doctors on 28th& 29th December <br></br>
                        The New College & MEASI opened FLOOD RELIEF CAMP and the active involvement in relief work of the Staffs and Students appreciated public as well as Government agencies during the recent Chennai floods in December</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setFourten(e => !e)} className='tab-open-btn'>✠ 2016-2017 </button>
            {
              fourten && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2016</td>
                      <td>PG & Research Department of Economics organized a two day National Seminar on “Social Exclusion in India towards Inclusion and Equity” on 6th & 7th January <br></br>
                        The P.G. Department of Historical Studies organized a special lecture on the occasion of 125th birth anniversary of Dr. B.R. Ambedkar and Dr. C. Lakshmanan, Associate Professor, Madras Institute of Development Studies, Chennai deliver the lecture on “Reminiscence of Dr. B.R Ambedkar’s Contribution to Modern India on 13th January <br></br>
                        PG & Research Department of Commerce organized a “One Day Workshop on The Companies Act 2013” under UGC Autonomous Grant on 23rd January <br></br>
                        Dr. J. Sulaiman, Assistant Professor appoint as Team Manager for the Tamil Nadu State NSS for the Republic Day Parade held on 26th January <br></br>
                        PG & Research Department of Chemistry organized One Day Seminar with the support of UGC Autonomous Grant on “Personality Development Programme” held on 28th January <br></br>
                        The Department of Sociology organized a one-day capacity building workshop on “Fear Management” on 28th January <br></br>
                        Delegates from Algeria and Bangladesh under the Arabic Study Circle visits the College on 5th February <br></br>
                        Al-Shaik Ali Omar Al-Abbasi, Chief Imam, Masjid al Aqsa, Palestine, opened the newly constructed Examination Hall (3rdfloor-AdministrativeBlock) on 19th February <br></br>
                        Mr. Sayed Sabir Pasha, International Football Player visits the College on 24th March <br></br>
                        Prof. Dr. H. Devaraj, Vice- Chairman, UGC, visits the College on 26th March <br></br>
                        NAAC Pear team Visits the College under Dr. S. Chandrashekar, Chairperson, Prof. A.K.Singh, member and Dr. Deo Subhash Atmaram, member Coordinator for re-accreditation of the College on 4th to 6th April <br></br>
                        The New College re-accredited with A grade and CGPA of 3.08 out of 4 point scale by NAAC <br></br>
                        Dr. S. Basher Ahamed, Associate Professor of English elected as Senate member of University of Madras
                        Dr. Major Zahid Husain took over as Principal on 1st June <br></br>
                        Dr. S. Thameem Sharief, Assistant Professor of Commerce awarded with Bhartiya Shiksha Ratan award by Global  <br></br>Achievers Foundation, New Delhi and Dr. Radhakrishnan Gold medal award for outstanding Individual Achievement in Education and Research by Global Economic Research Association, Chennai on September</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2017</td>
                      <td>

                        Prof. S.A. Sheik Mohamed, Associate Professor of English appointed as the Coordinator for IQAC <br></br>
                        E-Learning Centre for Research Scholars established (DST- FIST Sponsored) in the College Library <br></br>
                        Mr. Mohamed Rifath Sharook Raaj, B.Sc. Physics Student represented the College in many International programme with his Nano Satellite (KALAMSAT) <br></br>
                        His Excellency Hyung Tae Kim, Consul General, Republic of Korea visits the College on 19th September <br></br>
                        PG & Research Department of Chemistry organized One Day Seminar with the support of UGC Autonomous Grant on “Personality Development Programme” held on 28th January <br></br>
                        Mr. Abdulla Imran, Director, Administration Division, Ministry of Education, Government of Maldives visits the College on 19th September <br></br>
                        Dr. Ankit Katrodia, University of Kwa Zulu Natal, Durban, South Africa visits the College on 19th September <br></br>
                        His Highness Nawab Prince of Arcot Mohammed Abdul Ali Azimjah unanimously became the Chairman, Janab T. Rafeeq Ahamed Sahib as the Hon. Secretary and Janab Elias Sait Sahib as the Treasurer of MEASI, the parent body of New College <br></br>
                        Dr. Abdul Alim, Professor of Aligarh Muslim University visits the College on 21st September <br></br>
                        Publisher and Editor Nakeeran Gopal visits the College and inaugurated the student platform ‘D Society’ on 8th October <br></br>
                        Justice A.K. Rajan, Former Judge of Madras High Court, visits the College on 18th November</td>
                    </tr>
                  </table>
                </div>
              )
            }


            <button onClick={() => setFiftens(e => !e)} className='tab-open-btn'>✠ 2018-2019 </button>
            {
              fiftens && (
                <div >
                  <h2>Dept. of Historical Studies, The New College, Chennai-14.</h2>
                  <p style={{ textAlign: "center" }}>Prepared by Dr. T. Abdul Khadar, Associate Professor of History</p>
                  <table>
                    <tr>
                      <th>
                        S. No</th>
                      <th>Year</th>
                      <th>Illustration</th>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>2018</td>
                      <td>
                        Dr. Amanda Weidman, Associate Professor of Anthropology, Bryn Mawr College, Pennsylvania, USA visits the College on 12th January <br></br>
                        Dr. T.S.N. Sankara Narayanan, Emeritus Scientist, Chonbuk National University, Republic of Korea visits the College on 14th Febrary <br></br>
                        Justice Hariparanthaman, Former Judge of Madras High Court, visits the College on 15th February <br></br>
                        Dr. V.N. Mani, Principal Scientist & Head, Ultra & High Pure Electronics Division, Centre for Materials of Electronics Technology (C-MET) Government of India, Hyderabad visits the College on 27th February <br></br>
                        Dr. A. Abdul Jabbar, Head of the Dept. of Chemistry took over as Principal on 1st June <br></br>
                        Dr. Sultan Ahmed Ismail, Director, Eco Science Research Foundation visits the College on 14th July <br></br>
                        Justice F.M. Ibrahim Kalifulla, Former Judge, Supreme Court of India visits the College on 15th September <br></br>
                        Thiru U. Sagayam, IAS, Vice- Chairman, Science City, Government of Tamil Nadu visits the College on 17th September <br></br>
                        The UGC Expert Team for the Extension of Autonomous Status of the College under Prof. P.K. Radhakrishnan, Chairperson, Ms. Usha Arya, Coordinating Officer, Prof. Shri. Prakash Singh, Member, Dr. K.B. Sharma, Member, Dr. A. Vennila, State Nominee, and Dr. Rita John, University Nominee visiting the College on 29th & 30th October <br></br>
                        Department of English organized a National Conference on Literature and Identity Politics</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>2019</td>
                      <td>
                        Introduced B.A. Tamil and Business Economics <br></br>
                        Introduced B.Sc (I.T) <br></br>
                        Introduced B.Com (Accounting & Finance) <br></br>
                        Introduced M.Sc (Botany)</td>
                    </tr>
                  </table>
                </div>
              )
            }

          </div>

          {/* Seventh Tab Details */}

          <div className={toggle === 7 ? "show-tab-content" : 'tab-content'}>
            <h1>Document & Testimonials</h1>



            <div className='tab-para'>
              <div className='tab-img'>
                <img src='https://thenewcollege.edu.in/images/Certificate%20of%20Honour_page-0001.jpg' style={{ width: "75%", height: "auto" }} />
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default TheNewCollege;
